import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { TextPlugin } from 'gsap/TextPlugin'
import { CustomEase } from 'gsap/CustomEase'
import { motion } from './tokens'

/**
 * Ponto único de registro do GSAP (D25 — set-pieces do modelo do Ângelo). O contrato de movimento (ADR-004) vale
 * também para tweens em JS: só o easing do arco (`arco-in` / `arco-out`), durações dos tokens, e todo percurso
 * volta ao ponto de partida (timelines com repeat reiniciam do zero — 0% ≡ 100%).
 */
gsap.registerPlugin(ScrollTrigger, TextPlugin, CustomEase)

const bezier = (css: string) => css.replace(/^cubic-bezier\(|\)$/g, '')
export const EASE_OUT = CustomEase.create('arco-out', bezier(motion.easeArcoOut))
export const EASE_IN = CustomEase.create('arco-in', bezier(motion.easeArcoIn))
export const DUR = { fast: motion.durFastMs / 1000, base: motion.durBaseMs / 1000 }

export { gsap, ScrollTrigger }
export const prefersReducedMotion = () => typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
